import React from "react";
import { FaLinkedinIn, FaFacebook, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="font-josefin-sans">
      <div className="px-5 pt-20 lg:pt-28 bg-white md:px-10 lg:px-20 xl:px-44 main-container-for-logo-company-user-teacher flex flex-col md:flex-row justify-between">
        <div className="logo-here mb-6 md:mb-0 md:mr-8">
          <img src="/images/logo.png" alt="logo" className="w-24" />
          <p className="text-sm mt-2">Empowering students & freshers</p>
        </div>

        <div className="company mb-6 md:mb-0 md:mr-8">
          <h2 className="text-base font-bold mb-2 md:mb-4">Company</h2>
          <ul className="space-y-2 lg:text-sm">
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/career">Career</a>
            </li>
            <li>
              <a href="/contactUs">Contact Us</a>
            </li>
            <li>
              <a href="/privacy&policy">Privacy Policy</a>
            </li>
            <li>
              <a href="/term&conditions">Terms and Conditions</a>
            </li>
          </ul>
        </div>
        <div className="user mb-6 md:mb-0 md:mr-8">
          <h2 className="text-base font-bold mb-2 md:mb-4">User</h2>
          <ul className="space-y-2 lg:text-sm">
            <li>
              <a href="/blog">Blog</a>
            </li>
            <li>
              <a href="/user-topic">Topics</a>
            </li>
            <li>
              <a href="/pricing">Pricing</a>
            </li>
            <li>
              <a href="/magicAI">MagicAI</a>
            </li>
            <li>
              <a href="/feedback">Feedback</a>
            </li>
          </ul>
        </div>
        <div className="teacher mb-6 md:mb-0 md:mr-8">
          <h2 className="text-base font-bold mb-2 md:mb-4">Teach</h2>
          <ul className="space-y-2 lg:text-sm">
            <li>
              <a href="/problemsolverpage">Join</a>
            </li>
            <li>
              <a href="/expert-benefits">Benefits</a>
            </li>
          </ul>
        </div>
        <div className="startup-india">
          <h1 className="text-2xl text font-bold">DPIIT Recognised</h1>
          <img
            src="/images/startup.png"
            alt="Startup India"
            className="w-40 md:w-48 mt-4 md:mt-0 lg:mt-10"
          />
        </div>
      </div>
      <div className="mt-[20px] h-[1px] bg-gray-400"></div>
      <div className="px-5 py-3 md:py-0 flex flex-col items-center lg:flex-row lg:justify-between md:justify-between lg:py-3 xl:px-44 lg:p-20">
        <div className="text-gray-600 pb-3">
          &copy; {new Date().getFullYear()} Fynii | All rights reserved
        </div>

        <div className="flex flex-row lg:space-x-[25px]">
          <a
            href="https://linkedin.com/company/fynii"
            target="_blank"
            rel="noopener noreferrer"
            className="mr-4 lg:mr-0"
          >
            <FaLinkedinIn size={25} />
          </a>
          <a
            href="https://facebook.com/FyniiGlobal"
            target="_blank"
            rel="noopener noreferrer"
            className="mr-4 lg:mr-0"
          >
            <FaFacebook size={25} />
          </a>
          <a
            href="https://instagram.com/fynii_edu"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={25} />
          </a>
        </div>
      </div>
      <div className="flex text-xs md:text-sm justify-center mt-2 md:mt-3 lg:mt-0"></div>
    </footer>
  );
};

export default Footer;
